import React from 'react';

const Hero = () => {
  const handleScrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="hero" style={{ backgroundImage: 'url(/mainimage.png)' }}>
      <div className="hero__overlay"></div>
      <div className="hero__content container" data-aos="fade-up" data-aos-duration="900">
        <p className="hero__tagline">Trusted Freight Solutions</p>
        <h1 className="hero__title">
          Moving America<br /><span>Forward</span>
        </h1>
        <p className="hero__subtitle">
          Reliable OTR transportation across all 48 contiguous states —
          on time, every time, with 24/7 dispatch support.
        </p>
        <div className="hero__actions">
          <button className="hero__btn hero__btn--primary" onClick={handleScrollToContact}>
            Get a Quote
          </button>
          <a className="hero__btn hero__btn--outline" href="/apply">
            Drive For C.H.I.
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
